import styled, { css } from 'styled-components';
import {
  CARD_MIN_HEIGHT,
  CARD_MIN_HEIGHT_HO,
  OVERLAY_MIN_HEIGHT,
} from '@/app/components/search/components/Card/constants.ts';
import { CARD_TYPE } from '@/app/components/search/components/Card/types.ts';
import { CardBorderContainer } from '@/app/components/search/components/Card/CardBorder/styled.ts';

export const desktopStyles = css`
  display: flex;
`;

export const overlayDesktopStyles = css`
  display: flex;
  flex-direction: column;
  min-height: ${OVERLAY_MIN_HEIGHT};
`;

export const overlayMobileStyles = css`
  display: flex;
  width: calc(100vw - 32px);
  min-height: unset;
  height: 100%;
  align-items: stretch;
`;

export const showCarouselControlsOnHover = css`
  &:hover {
    .arrow-left,
    .arrow-right {
      opacity: 0.5;
    }
    .dots {
      opacity: 1;
    }
  }
`;

const hoverStylesWhenTooltipIsNotHovered = css`
  // apply specific hover styles only in browsers where :not and :has are supported
  @supports selector(:not(*)) and selector(:has(*)) {
    &:hover {
      // reset hover effect to default shadow
      box-shadow: ${({ theme }): string => theme?.kallisto?.shadow?.mediumDownShadow};
    }
    // don't apply hover styles when the tooltip is hovered
    &:not(:has([role='tooltip']:hover)):hover {
      box-shadow: ${({ theme }): string => theme?.kallisto?.shadow?.largeDownShadow};
    }
  }
`;

const standardHoverStyles = css`
  transition: box-shadow 0.2s ease-in-out;
  &:hover {
    box-shadow: ${({ theme }): string => theme?.kallisto?.shadow?.largeDownShadow};
  }
`;

export const hoverStyles = css<{ comparisonEnabled?: boolean }>`
  cursor: pointer;
  ${standardHoverStyles};
  ${({ comparisonEnabled }) => comparisonEnabled && hoverStylesWhenTooltipIsNotHovered}
`;

const activeStyles = css`
  &:active {
    box-shadow: ${({ theme }): string => theme?.kallisto?.shadow?.smallDownShadow};
  }
`;

export const preselectedStyled = css`
  margin-top: 34px;

  &:first-child {
    margin-top: 18px;
  }

  ${CardBorderContainer} {
    z-index: -1;
  }
`;

const hotelOnlyStyles = css`
  min-height: ${CARD_MIN_HEIGHT_HO};
`;

const mobileOnlyStyles = css`
  min-height: unset;
`;

export const CardOuterContainer = styled.div<{ isPreselected?: boolean }>`
  position: relative;
  max-width: 100%;

  ${({ isPreselected }) => isPreselected && preselectedStyled};
`;

const cardTypesStyles = css<{ type?: CARD_TYPE }>`
  ${({ type }) => {
    if (type === CARD_TYPE.MODAL) {
      return css`
        flex-direction: row !important;
        min-height: unset !important;
      `;
    }
    return css``;
  }}
`;

export const CardContainer = styled.div<{
  isOverlay: boolean;
  isNotClickable?: boolean;
  isPreselected?: boolean;
  comparisonEnabled?: boolean;
  isHO?: boolean;
  ref?: React.MutableRefObject<HTMLDivElement | undefined>;
  type?: CARD_TYPE;
}>`
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};
  position: relative;
  width: 100%;
  min-height: ${CARD_MIN_HEIGHT};
  box-shadow: ${({ theme }): string => theme?.kallisto?.shadow?.mediumDownShadow};
  border-radius: 8px;
  max-width: 100%;
  z-index: 1;

  * {
    letter-spacing: 0;
  }

  ${({ isNotClickable }) => !isNotClickable && hoverStyles};
  @media (max-width: 767px) {
    ${mobileOnlyStyles};
    ${({ isOverlay }) => isOverlay && overlayMobileStyles};
  }
  @media (min-width: 768px) {
    ${desktopStyles};
    ${({ isOverlay }) => isOverlay && overlayDesktopStyles};
  }
  ${({ isHO }) => isHO && hotelOnlyStyles};
  ${({ isPreselected }) => isPreselected && preselectedStyled};
  ${activeStyles};
  ${showCarouselControlsOnHover};
  ${cardTypesStyles};
`;
